import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css'; // Ensure this path is correct
import Logo from '../assets/logo.png';

function Footer() {
  return (
	<footer className="footer">
	  {/* Navigation Section */}
	  {/* Logo */}
	  {/* Logo */}
	  <div className="footer-logo">
		<Link to="/">
		  <img src={Logo} alt="Logo" />
		</Link>
	  </div>
	  <div className="footer-nav">
		<ul className="footer-links">
		  <li><Link to="/">Home</Link></li>
		  <li><Link to="/programs">Programs</Link></li>
		  <li><Link to="/periodization">Periodization</Link></li>
		  <li><Link to="/about">About Us</Link></li>
		  <li><Link to="/drops">Drops</Link></li>
		  <li><Link to="/equipment">Equipment</Link></li>
		  <li><Link to="/app">Download App</Link></li>
		</ul>
	  </div>

	  {/* Terms & Copyright Section */}
	  <div className="footer-bottom">
		<div className="footer-terms">
		  <Link to="/privacy">Privacy</Link> | <Link to="/terms">Terms and Conditions</Link> | <Link to="/release-notes">Release Notes</Link>
		</div>
		<div className="footer-copyright">
		  © 2025 All rights reserved. <a href="https://beginthework.com" target="_blank"  rel="noreferrer">Begin the Work, LLC</a>
		</div>
	  </div>
	</footer>
  );
}

export default Footer;